// TODO: replace console with actual sentry logger logic

export class SentryLogger {
  constructor(logLevel) {
    if (logLevel === void 0) {
      logLevel = 'error';
    }
    this.logLevel = logLevel;
  }
  debug(message) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    this.logLevel !== 'error' && console.debug(message, ...args);
  }
  info(message) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    this.logLevel !== 'error' && console.info(message, ...args);
  }
  warn(message) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    this.logLevel !== 'error' && console.warn(message, ...args);
  }
  error(message) {
    for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      args[_key4 - 1] = arguments[_key4];
    }
    console.error(message, ...args);
  }
}
//# sourceMappingURL=SentryLogger.js.map